import initLicenseSlider from "./init-license-slider";
import initParticipantsSlider from "./init-participants-slider";
import initReviewsSlider from "./init-reviews-slider";

const sliders = () => {
    initLicenseSlider();
    initParticipantsSlider();
    initReviewsSlider();
}

export default sliders;
